module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "auth",
      ("auth--" + _vm.slug),
      "group",
      "group--first-last" ]
  }, [(_vm.titleSet !== null) ? _c(_vm.modal ? "h2" : "h1", {
    tag: "tag",
    class: [
      "mt0",
      _vm.modal ? "h3" : "h2",
      {
        'mt0': _vm.modal,
      }
    ]
  }, [_vm._v(_vm._s(_vm.titleSet))]) : _vm._e(), _vm._v(" "), (_vm.copySet) ? _c('p', {
    staticClass: "p tc",
    domProps: {
      "innerHTML": _vm._s(_vm.successCopy && _vm.status.success ? _vm.successCopy : _vm.copySet)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("top-link"), _vm._v(" "), (_vm.slug === "login") ? _c('p', {
    staticClass: "p small"
  }, [_vm._v("Haven't got an account? "), _c('module-link', {
    attrs: {
      "link": "register-patient"
    }
  }, [_vm._v("Sign Up")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.successCopy || (_vm.successCopy && !_vm.status.success)),
      expression: "!successCopy || (successCopy && !status.success)"
    }]
  }, [_c('module-form', {
    class: [
      "auth__form",
      ("auth__form--" + _vm.slug) ],
    attrs: {
      "form-id": _vm.formId,
      "fields": _vm.fields[_vm.slug],
      "action": _vm.requestAction,
      "success": _vm.success,
      "fail": _vm.fail,
      "submit": _vm.submitSet,
      "button-size": "m",
      "button": "primary"
    }
  }, [_c('div', {
    staticClass: "form__before-button",
    attrs: {
      "slot": "before-submit"
    },
    slot: "before-submit"
  }, [_vm._t("before-submit")], 2)])], 1), _vm._v(" "), (_vm.hasFooter) ? _c('p', {
    staticClass: "auth__footer small tc"
  }, [_vm._t("link")], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33153b5f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Auth.vue
// module id = 118
// module chunks = 3